import React, { useEffect } from 'react';
import { Modal, Icon, Tooltip, Input, Button } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { fetchACCPBoss, fetchACCPBossAvailable, fetchACCPBossFilter, accpBossClear, accpBossFilterClear } from 'app/actions/ACCPBossActions';
import { getACCPBoss, getACCPBossAvailable, getACCPBossFilter, getIsLoadingACCPBoss, getIsLoadingACCPBossAvailable } from 'app/reducers';
import IconButton from '@material-ui/core/IconButton';
import ApiService from 'app/services/ApiService';
import { setTimeout } from 'timers';
import isEmpty from 'app/utils/IsEmpty';

export default function ACCPBossTableContainer(props) {
    const { classes } = props;
    const { confirm } = Modal;
    const { siteId } = useSelector(state => state.Auth)

    let searchInput = React.createRef();
    const pagination = props.pagination;
    const sorter = props.sorter;
    let offset = 0;
    let limit = 0;
    let column = null;
    let order = null;

    const columns = [
        {
            title: 'Ficha',
            dataIndex: 'employeeId',
            key: 'employeeId',
            sorter: true,
            width: 100,
            ellipsis: true

        },
        {
            title: 'Nombre',
            dataIndex: 'employeeName',
            key: 'employeeName',
            sorter: true,
            width: 350,
            ellipsis: true

        },
        {
            title: 'Compañía',
            dataIndex: 'subdirectionName',
            key: 'subdirectionName',
            sorter: true,
            width: 200,
            ellipsis: true

        },
        {
            title: 'Puesto',
            dataIndex: 'categoryName',
            key: 'categoryName',
            sorter: true,
            width: 350,
            ellipsis: true

        },
        {

        },
        {
            title: 'Acciones',
            key: 'action',
            dataIndex: 'employeeId',
            fixed: 'right',
            width: siteId === "HUB" ? 120 : 80,
            render: (text, record) => (
                <div className={classes.buttons}>
                    {
                        siteId === "HUB" ?
                            <Tooltip placement="bottomLeft" title={'Eliminar'}>
                                <IconButton className={classes.deleteIcon} onClick={() => showConfirmDelete(record)}>
                                    <Icon type="delete" />
                                </IconButton>
                            </Tooltip>
                            : null
                    }
                </div>
            )
        }
    ];

    const columnsNew = [
        {
            ...getColumnSearchProps('employeeId'),
            title: 'Ficha',
            dataIndex: 'employeeId',
            key: 'employeeId',
            width: 100,
            ellipsis: true,
            sorter: (a, b) => a.employeeId - b.employeeId,

        },
        {
            ...getColumnSearchProps('employeeName'),
            title: 'Nombre',
            dataIndex: 'employeeName',
            key: 'employeeName',
            width: 300,
            ellipsis: true,
            sorter: (a, b) => a.employeeName.localeCompare(b.employeeName)

        }
    ];

    const showConfirmDelete = (param) => {
        confirm({
            title: '¿Eliminar Jefe de AC y CP?',
            content: param.employeeId + ' - ' + param.employeeName,
            okText: 'Eliminar',
            okType: 'danger',
            cancelText: 'Cancelar',
            onOk() {
                return deleteBoss(param);
            },
            onCancel() { },
        });

    }

    async function deleteBoss(param) {
        await ApiService.setEmployeeBoss({ boss: false, listEmployeeId: [param.employeeId] }, 'PUT').then(res => {
            dispatch(accpBossFilterClear());
            dispatch(fetchACCPBossFilter());
            dispatch(accpBossClear());
            props.setFiltroNombre(props.FiltroNombre.filter(x => x !== param.employeeName));
            dispatch(fetchACCPBoss({
                employee: props.FiltroNombre.filter(x => x !== param.employeeName).join(','),
                sortColumn: column,
                sortDir: order, offset: offset, limit: limit
            }));
            fetchACCPBossAvailableAction();
            const modal = Modal.success({
                title: `Eliminado Correctamente`,
                content: '',
            });

            setTimeout(function () {
                modal.destroy();
            }, 3000)

        });
    }

    let accpBoss = useSelector(getACCPBoss);
    let accpBossAvailable = useSelector(getACCPBossAvailable);
    let accpBossFilter = useSelector(getACCPBossFilter);

    let isLoading = useSelector(getIsLoadingACCPBoss);
    let isLoadingAvailable = useSelector(getIsLoadingACCPBossAvailable);
    const dispatch = useDispatch();

    useEffect(() => {
        if (isEmpty(accpBoss)) fetchACCPBossAction();
        if (isEmpty(accpBossAvailable)) fetchACCPBossAvailableAction();
        if (isEmpty(accpBossFilter)) fetchACCPBossFilterAction();
    }, []);

    const handleTableChange = (pagination, filters, sorter) => {

        props.setPagination(pagination);
        props.setSorter(sorter);
        if (Object.keys(sorter).length > 0) {
            column = sorter.field;
            order = sorter.order === "ascend" ? "ASC" : "DESC";
        }
        else {
            column = '';
            order = '';
        }

        dispatch(fetchACCPBoss(
            {
                employee: props.FiltroNombre.join('|'),
                CommunicationProgramName: (typeof props.formData.CommunicationProgramName === "undefined") ? '' : props.formData.CommunicationProgramName,
                CommunicationProgramDescription: (typeof props.formData.CommunicationProgramDescription === "undefined") ? '' : props.formData.CommunicationProgramDescription,
                sortColumn: column,
                sortDir: order,
                offset: ((pagination.current - 1) * pagination.pageSize),
                limit: pagination.pageSize
            }));
    };

    function getColumnSearchProps(dataIndex) {
        return {
            filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                <div style={{ padding: 8 }}>
                    <Input
                        ref={node => {
                            searchInput = node;
                        }}
                        placeholder={`Buscar...`}
                        value={selectedKeys[0]}
                        onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                        onPressEnter={() => handleSearch(selectedKeys, confirm)}
                        style={{ width: 188, marginBottom: 8, display: 'block' }}
                    />
                    <Button
                        type="primary"
                        onClick={() => handleSearch(selectedKeys, confirm)}
                        icon="search"
                        size="small"
                        style={{ width: 90, marginRight: 8 }}
                    >
                        Buscar
                    </Button>
                    <Button onClick={() => handleReset(clearFilters)} size="small" style={{ width: 90 }}>
                        Limpiar
                    </Button>
                </div>
            ),
            filterIcon: filtered => (
                <Icon type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
            ),
            onFilter: (value, record) =>
                record[dataIndex]
                    .toString()
                    .toLowerCase()
                    .includes(value.toLowerCase()),
            onFilterDropdownVisibleChange: visible => {
                if (visible) {
                    setTimeout(() => searchInput.select());
                }
            }
        }
    }

    const handleSearch = (selectedKeys, confirm) => {
        confirm();
    };

    const handleReset = clearFilters => {
        clearFilters();
    };

    //Load
    if (pagination != null) {
        offset = (0 * pagination.pageSize);
        limit = (pagination.pageSize);

        if (!isLoading && accpBoss.length > 0) {
            pagination.total = accpBoss[0].totalcount;
        }
        else {
            pagination.total = 0;
        }
    }

    if (sorter != null) {
        column = sorter.field;
        order = sorter.order === "ascend" ? "ASC" : "DESC";
    }



    const fetchACCPBossAction = () => dispatch(fetchACCPBoss({
        employee: props.FiltroNombre !== undefined ? props.FiltroNombre.join(',') : '',
        sortColumn: column,
        sortDir: order, offset: offset, limit: limit
    }));
    const fetchACCPBossAvailableAction = () => dispatch(fetchACCPBossAvailable())
    const fetchACCPBossFilterAction = () => dispatch(fetchACCPBossFilter())
    accpBossAvailable.map(item => item['key'] = item.employeeId);
    return (props.children({ pagination: pagination, cols: columns, columnsNews: columnsNew, accpBoss, accpBossAvailable, accpBossFilter, isLoading, isLoadingAvailable, handleTableChange: handleTableChange }));
}

